import { createContext, useContext } from 'react';

const SocketContext = createContext({
    socket: '',
    globalState: "",
    setGlobalState: ""
});
export default SocketContext;

export const useGlobalContext = () => useContext(SocketContext);
